import { put } from '..';
import { ensureDefaultRoleReadPermissions } from '../../constants/UserPermissions';

const editRole = (
  name: string,
  roleDescription: string,
  permissions: string[],
  roleId: string,
  roleColor: string,
) => put(
  `users/roles/${roleId}`,
  {
    name,
    description: roleDescription,
    permissions: ensureDefaultRoleReadPermissions(permissions),
    roleId,
    color: roleColor,
  },
);

export default editRole;
